import React from 'react'
import NavLayout from '../../Layouts/NavLayout'
import SettingsIcon from '../../../../../../generic/icons/IconLib/SettingsIcon'
import SlidersIcon from '../../../../../../generic/icons/IconLib/SlidersIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import NavItem from './Components/NavItem'
import { useTranslation } from 'react-i18next'
import ShieldIcon from '../../../../../../generic/icons/IconLib/ShieldIcon'
// import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'

export interface INavItem {
  name: string
  icon: React.ReactNode
  path: string
}

const SettingsNav = () => {
  const [t] = useTranslation(['settings'])

  return (
    <NavLayout>  
      <NavItem 
        name={t('account')}
        icon={<UserIcon />}
        path='/main/settings/account'
      />
      <NavItem 
        name={t('preferences')}
        icon={<SlidersIcon />}
        path='/main/settings/preferences'
      />
      <NavItem 
        name="ניהול מסכים"
        icon={<SettingsIcon />}
        path='/main/settings/feature-control'
      />
      <NavItem 
        name="אבטחת מידע"
        icon={<ShieldIcon />}
        path='/main/settings/security'
      />
    </NavLayout>
  )
}

export default SettingsNav